import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--border);
  height: var(--nav-h);
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 50;
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--nav-h);
  width: 100%;
  max-width: var(--maxw);
  padding: 0 24px;
`;

export const NavLogo = styled(LinkR)`
  color: var(--ink);
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
`;

export const LogoDot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--accent);
  display: inline-block;
  margin-top: 4px;
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 820px) {
    display: flex;
    align-items: center;
    color: var(--ink);
    font-size: 1.6rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;

  @media screen and (max-width: 820px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  display: flex;
  align-items: center;
`;

export const NavLinks = styled(LinkS)`
  color: var(--text);
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 8px 14px;
  border-radius: var(--radius-pill);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease;

  &:hover {
    color: var(--ink);
    background: var(--bg-subtle);
  }

  &.active {
    color: var(--accent-strong);
  }
`;

export const NavCta = styled(LinkS)`
  margin-left: 10px;
  border-radius: var(--radius-pill);
  background: var(--ink);
  white-space: nowrap;
  padding: 10px 20px;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.18s ease, background 0.18s ease;

  &:hover {
    background: var(--accent-strong);
    transform: translateY(-1px);
  }

  @media screen and (max-width: 820px) {
    display: none;
  }
`;
